import { color, spacing } from "@universityofmaryland/web-token-library";
import "../typography/font-face/index.js";
import "../typography/campaign.js";
import "../typography/elements.js";
import { small, large } from "../typography/sans.js";
import "../typography/serif.js";
import "../typography/stats.js";
import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const classNamePrefix = "umd-table";
const inline = objectWithClassName({
  borderCollapse: "collapse",
  display: "block",
  overflowX: "auto",
  tableLayout: "fixed",
  maxWidth: "100%",
  "& th": large,
  "& td": small,
  "& th, & td": {
    padding: `${spacing.md}`,
    verticalAlign: "top",
    "&:first-child": {
      paddingLeft: spacing.md
    },
    "&:last-Child": {
      paddingRight: spacing.md
    }
  },
  "& thead th": {
    background: color.gray.lighter,
    color: color.black,
    textAlign: "left"
  },
  "& tbody tr": {
    borderTop: `1px solid ${color.gray.light}`
  },
  "& tr:nth-child(even)": {
    background: color.gray.lightest
  },
  className: [
    `${classNamePrefix}-inline`,
    /** @deprecated Use 'umd-table-inline' instead */
    `umd-rich-text-inline-table`
  ]
});
export {
  inline
};
//# sourceMappingURL=table.js.map
